let map = {
    mymap: '',
    style: '',
    themeUrl: wpurls.siteUrl,
    png: '',
    pngFocus: '',
    popUpContent: '',
    locations: mapJson,
    refreshTrigger: [],

    init: function () {
        if(mapJson.length > 0) {

            // Config 
            var notMobile = !L.Browser.mobile;
            map.mymap = L.map('leaflet-map', {
                doubleClickZoom: true,
                dragging: notMobile,
                scrollWheelZoom: false,
                maxZoom: 20
            });

            // Vector tiles style
            map.mymap.setView([0, 0], 1);
            const mtLayer = L.maptilerLayer({
                apiKey: 'ZeLDOvhY1MhObtmWCnbv', // artwai = lZDYFM07RLhTSLeuMnfW
                style: "e6581b85-defe-4399-8cef-509654322d9b", // artwai = 1cb22ac8-507f-49f7-8943-51f1aac14806
            }).addTo(map.mymap);

            // Raster tiles style
            //map.style = L.tileLayer('https://api.maptiler.com/maps/winter-v2/256/{z}/{x}/{y}.png?key=y7GXEnJx15LSk7R6yH6r');
            //map.mymap.addLayer(map.style);

            // Custom icon
            map.png = L.icon({
                iconUrl: map.themeUrl + '/assets/lib/leaflet/marker-icon.svg',
                shadowUrl: map.themeUrl + '/assets/lib/leaflet/marker-shadow.png',
                iconSize: [47, 64],
                iconAnchor: [23.5, 64],
                shadowSize: [30, 45],
                shadowAnchor: [4, 62],
                popupAnchor: [0, -64]
            });

            // Marker cluster group
            var newMarkerGroup = L.markerClusterGroup({
                icon: map.png
            });

            // Search only on list page
            if(!map.locations[0].isSingular) {
                var GeoSearchControl = GeoSearch.GeoSearchControl;
                var OpenStreetMapProvider = GeoSearch.OpenStreetMapProvider;
                var provider = new OpenStreetMapProvider({});

                //  Define search controls
                var searchControl = new GeoSearchControl({
                    provider: provider,
                    style: 'bar',
                    showMarker: false,
                    showPopup: false,
                    searchLabel: wpurls.tradLocation,
                    marker: {
                        draggable: false
                    },
                    autoClose: true,
                });

                // Add searchbar to the map
                map.mymap.addControl(searchControl);

                /* Create new layer for markers  */
                map.mymap.on('geosearch/showlocation', function(e) {
                    // loop with 2 marker near search
                    var feature = {
                        "type": "Feature",
                        "geometry": {
                            "type": "MultiPoint",
                            "coordinates": []
                        }
                    };
                    boundsArr.forEach(location => {
                        feature.geometry.coordinates.push([location[0], location[1]]);
                    });
                    var boundsGeoJson = new L.GeoJSON(feature);
                    var nearestResult = leafletKnn(boundsGeoJson).nearest(L.latLng(e.location.x, e.location.y), 1);
                    var nearestArr = [];
                    if(nearestResult.length > 0) {
                        nearestResult.forEach(location => {
                            nearestArr.push([location.lon, location.lat]);
                        });
                    }
                    nearestArr.push([e.location.y, e.location.x]);
                    var boundsNearest = L.latLngBounds(nearestArr);
                    map.mymap.fitBounds(boundsNearest, {
                        paddingTopLeft : [100, 100],
                        paddingBottomRight:	[50, 50],
                    });
                    //map.mymap.setZoom(12);
                });
            }

            let boundsArr = [];
            map.locations.forEach(location => {
                if (location.address.latitude.length > 0 && location.address.longitude.length > 0) {
                    // Init Bounds for zoom dynamic
                    boundsArr.push([location.address.latitude, location.address.longitude]);
                    
                    // HTML popup marker
                    map.popUpContent = `
                    <a href="${location.url}">
                        <div class="popup-description">
                            <p class="card-title">${location.title}</p>
                            <p class="card-adress">${location.address.city}</p>
                        </div>
                    </a>`;
                    
                    // Init Group marker
                    var newMarker = new L.marker([location.address.latitude, location.address.longitude], {
                        icon: map.png
                    });

                    // Popup au clic sur le marker seulement
                    if(!map.locations[0].isSingular) {
                        let popup = new L.Popup({
                            minWidth:300
                        });
                        popup.setContent(map.popUpContent);
                        newMarker.bindPopup(popup);
                    }

                    // Add marker to group marker
                    newMarkerGroup.addLayer(newMarker);
                }
            });

            map.mymap.addLayer(newMarkerGroup);            

            // Zoom map with all marker dynamic - page liste
            // Zoom map with marker center - page détail
            if(boundsArr.length > 0) {
                var bounds = [];
                bounds = L.latLngBounds(boundsArr);
                if (map.locations[0].isSingular) {
                    map.mymap.fitBounds(bounds, {
                        paddingTopLeft : [50, 50],
                        paddingBottomRight:	[50, 50],
                    });
                    map.mymap.setZoom(15);
                } else {
                    map.mymap.fitBounds(bounds, {
                        paddingTopLeft : [100, 100],
                        paddingBottomRight:	[50, 50],
                    });
                }
            }
        }
    }
};
document.addEventListener('DOMContentLoaded', map.init);